// promise polyfill
require('es6-promise/auto')

// classlist polyfill
require('./polyfill/classlist')

// azure application insights
require('./helpers/insights')

// initialize api
require('./api')

try {
  window._ = require('lodash')
  window.Popper = require('popper.js').default
  window.$ = window.jQuery = require('jquery')

  require('bootstrap')
} catch (e) { }

// setup CSP nonce
const nonce = document.head.querySelector('meta[name="nonce"]')

// register nonce from backend
if (nonce) {
  __webpack_nonce__ = nonce.content
}
